import React from "react";
import { useLocation } from "react-router-dom";

import PageHeader from "../../../../componets/PageHeader";
import NavBarTwo from "../../../../componets/NavBarTwo";
import stickerMakerUrls from "../../../../configs/sticker_maker/stickerMakerUrls";
import {isActiveUrl} from "../../../../helpers/UrlHelpers";

const NAV_ITEMS: {[index: number]: any} = {
  1: {
    id: 1,
    name: 'Sticker Packs',
    url: stickerMakerUrls.reviewsPath()
  },
  2: {
    id: 2,
    name: 'Stickers',
    url: stickerMakerUrls.stickersReviewsPath()
  },
};

interface PropsInterface {
  title: string;
}

const _PageHeader = ({ title }: PropsInterface) => {
  const { pathname }  = useLocation();
  const activeItem    = Object.values(NAV_ITEMS).find(e => isActiveUrl(e.url, pathname));

  return (
    <PageHeader
      title={title}
      breadcrumbs={[activeItem?.name]}
    >
      <NavBarTwo
        items={NAV_ITEMS}
        itemIds={Object.keys(NAV_ITEMS)}
        activeId={activeItem?.id}
      />
    </PageHeader>
  );
}

export default _PageHeader;
